import { VehicleType } from '@/hooks/useVehicleTypes';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Switch } from '@/components/ui/switch';
import { Package } from 'lucide-react';

interface VehicleTypeSimpleListProps {
  vehicleTypes: VehicleType[];
  onEdit: (type: VehicleType) => void;
  onDelete: (type: VehicleType) => void;
  onToggleActive: (type: VehicleType) => void;
}

export function VehicleTypeSimpleList({ 
  vehicleTypes, 
  onEdit,
  onToggleActive 
}: VehicleTypeSimpleListProps) {
  if (vehicleTypes.length === 0) {
    return (
      <Card>
        <CardContent className="pt-6">
          <div className="text-center py-8">
            <Package className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
            <p className="text-muted-foreground">Nenhum tipo de veículo cadastrado</p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">
          Tipo de veículo
        </CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <div className="divide-y">
          {vehicleTypes.map((type) => (
            <button
              key={type.id}
              type="button"
              onClick={() => onEdit(type)}
              className="w-full flex items-center justify-between px-4 py-3 hover:bg-muted/50 transition-colors"
            >
              {/* Coluna 1: imagem */}
              <div className="flex items-center gap-3">
                {type.image_url ? (
                  <img
                    src={type.image_url}
                    alt={type.name}
                    className="h-10 w-10 rounded-md object-cover border border-border"
                  />
                ) : (
                  <div className="h-10 w-10 rounded-md border border-dashed border-border flex items-center justify-center text-muted-foreground text-xs">
                    N/A
                  </div>
                )}

                {/* Coluna 2: nome/tipo */}
                <div className="flex flex-col items-start">
                  <span className="text-sm font-medium">{type.name}</span>
                  <span className="text-xs text-muted-foreground">Tipo de veículo</span>
                </div>
              </div>

              {/* Coluna 3: Switch */}
              <Switch
                checked={type.is_active}
                onCheckedChange={(checked) => {
                  // Previne propagação do evento para não abrir modal de edição
                  event?.stopPropagation();
                  onToggleActive(type);
                }}
                onClick={(e) => e.stopPropagation()}
              />
            </button>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
